import { render, staticRenderFns } from "./ButtonGetInto.vue?vue&type=template&id=35e32ecc&"
import script from "./ButtonGetInto.vue?vue&type=script&lang=js&"
export * from "./ButtonGetInto.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGetInto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports